import { getPhoneMaxLength, isMalaysia } from './tenant'

const panRegex = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/
const gstRegex =
  /^([0][1-9]|[1-2][0-9]|[3][0-7])([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1})+$/
const addressRegex = /^[a-zA-Z0-9\s,#-]*$/
const specialCharRegex = /[^a-zA-Z0-9\s,#-]/
// MYS allows additional special characters in addresses: & / - , . ' ( ) # @ : ;
const mysAddressRegex = /^[a-zA-Z0-9\s,#&/,.'()@:;-]*$/
const mysSpecialCharRegex = /[^a-zA-Z0-9\s,#&/,.'()@:;-]/
const VALID_TLDS = [
  'com',
  'net',
  'org',
  'edu',
  'gov',
  'io',
  'co',
  'us',
  'uk',
  'info',
  'biz',
  'dev',
  'app',
  'ai',
  'me',
  'ca',
  'in',
]
function isValidTLD(email) {
  const parts = email.toLowerCase().split('.')
  if (parts.length < 2) return false

  const tld = parts[parts.length - 1]
  return VALID_TLDS.includes(tld)
}

export function isEmailValid(email: string) {
  const emailRegex = /^[a-zA-Z0-9]([a-zA-Z0-9._-]*[a-zA-Z0-9])?@[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?(\.[a-zA-Z]{2,10})+$/
  return emailRegex.test(email)
}
export function isPanorGSTValid(panGst: string) {
  return isPanValid(panGst) || isGstValid(panGst)
}

export function isPanValid(pan: string) {
  // TODO: !! Remove this hardcoded check.
  if (pan === '27AAICA3919J1CT') {
    return true
  }
  return panRegex.test(pan)
}

export function isGstValid(gst: string) {
  // TODO: !! Remove this hardcoded check.
  if (gst === '27AAICA3919J1CT') {
    return true
  }
  return gstRegex.test(gst)
}

export function isEmpty(value: any) {
  return value === '' || value === null || value === undefined
}

export function isValidAddressString(value: string) {
  if (isMalaysia()) {
    return mysAddressRegex.test(value?.trim())
  }
  return addressRegex.test(value?.trim())
}

export function containsSpecialCharacters(value: string) {
  if (isMalaysia()) {
    return mysSpecialCharRegex.test(value?.trim())
  }
  return specialCharRegex.test(value?.trim())
}

export function sanitizeAddressString(value: string) {
  if (!value) return value
  return value.replace(/[^a-zA-Z0-9\s,#-]/g, '').trim()
}

// Allowed special chars for MYS names: & / - , . ' ( ) # @ : ;
const MYS_NAME_ALLOWED_REGEX = /[^a-zA-Z\s&/,.'()#@:;-]/g

const MYS_NAME_VALID_REGEX = /^[a-zA-Z\s&/,.'()#@:;-]{2,50}$/

/**
 * Sanitize a name value for Malaysia tenant.
 * Allows letters, spaces, and specific special characters.
 * For non-MYS tenants, strips all special characters.
 */
export function sanitizePersonName(value: string): string {
  if (!value) return value
  if (isMalaysia()) {
    return value.replace(MYS_NAME_ALLOWED_REGEX, '')
  }
  return value.replace(/[^a-zA-Z\s]/g, '')
}

export function isValidMobileNumber(number: string) {
  const mobileRegex = /^[6-9]\d{9}$/
  return mobileRegex.test(number)
}
export function isValidMobileNumberWithCountryCode(
  number: string,
  countryCode: string
): boolean {
  let digits = number?.replace(/\D/g, '') || ''

  if (countryCode === '+971') {
    return /^5\d{8}$/.test(digits)
  }

  if (countryCode === '+60') {
    // Normalize optional country-code-prefixed values to local format.
    if (digits.startsWith('60')) {
      digits = digits.substring(2)
    }

    // Strict MYS rule: 9-10 digits starting with 1.
    return /^1\d{8,9}$/.test(digits)
  }

  const maxLength = getPhoneMaxLength()

  const startPatterns: Record<string, string> = {
    '+91': '[6-9]', // India
    '+65': '[689]', // Singapore
    '+63': '9', // Philippines
  }

  const startPattern = startPatterns[countryCode] || '[0-9]'
  const regex = new RegExp(`^${startPattern}\\d{${maxLength - 1}}$`)

  return regex.test(digits)
}

export function isValidName(name: string) {
  if (isMalaysia()) {
    return MYS_NAME_VALID_REGEX.test(name)
  }
  const nameRegex = /^[A-Za-z\s'-]{2,50}$/
  return nameRegex.test(name)
}
export function isValidShopName(name: string) {
  if (isMalaysia()) {
    return /^[a-zA-Z0-9\s&/,.'()#@:;-]{2,50}$/.test(name)
  }
  const nameRegex = /^[a-zA-Z0-9&'.\-\s]{2,50}$/
  return nameRegex.test(name)
}
